import React from 'react';
import { withRouter } from 'react-router-dom';
import Constants from '../utils/Constants';
import NoDataFound from './NoDataFound';
class VendorRoomViewScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }
    render() {
        const { data } = this.props;
        return (
            <div className="content-part px-5 py-4 list">
                <div className="agent-details">
                    <div className='row'>
                        <div className="col-md-8">
                            <div className='row'>
                                <div className='col-6 text-bold'>
                                    Room Number :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.patientRoomId}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    Room Name :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.patientRoomName}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    Room code :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.encryptRoomId}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5 me-5 pb-3 d-flex justify-content-start">
                        <button type="button" className="btn input-btn" onClick={() => this.props.history.goBack()} >{Constants.BACK}</button>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(VendorRoomViewScreen);